import store from 'source/store';

function validateOnboardingSettingsRoute(to, from, next) {
    const DEFAULT_TAB = 'configurations';

    const tab = to.query.tab || DEFAULT_TAB;
    const isValidTab = ['members', 'configurations'].includes(tab);

    if (isValidTab) {
        next();
    } else {
        next({ name: 'page-not-found' });
    }
}

function validateTemplatesTabRoute(to, from, next) {
    const DEFAULT_TAB = 'myTemplates';

    const tab = to.query.tab || DEFAULT_TAB;
    const isValidTab = ['myTemplates', 'companyTemplates', 'systemTemplates', 'archivedTemplates'].includes(tab);

    if (isValidTab) {
        next();
    } else {
        next({ name: 'page-not-found' });
    }
}

function validatePlatformSettingsRoute(to, from, next) {
    const acceptedQuery = {
        tab: '', page: '', toast: '',
        pk: '', source: '', isPartnerView: ''
    };
    const isNotValidQuery = Object.keys(to.query).some(
            key => !(key in acceptedQuery)
        );

    const DEFAULT_TAB = 'templates';

    const tab = to.query.tab || DEFAULT_TAB;
    const isValidTab = ['templates', 'partners'].includes(tab);

    if (isValidTab && !isNotValidQuery) {
        next();
    } else {
        next({ name: 'page-not-found' });
    }
}

function canViewPayrolls(to, from, next) {
    const { can_view_payroll } = store.state.auth.user.user_profile;

    if (!can_view_payroll) {
        next({ name: 'access-denied', replace: true });
    } else {
        next();
    }
}

export default [{
    path: 'administration/',
    name: 'administrator-dashboard',
    component: () =>
        import ('source/pages/root/AdminPageGroup.vue'),
    meta: {
        title: 'Administrator - HQZen',
        canDisplayGlobalModals: true,
        isAdministratorRoute: true,
    },

    beforeEnter: (to, from, next) => {
        let workforcePk = to.params.workforce_id;
        let userProfile = store.state.auth.user.user_profile;
        let workforcePerms = [];
        for (const [key, value] of Object.entries(userProfile.client_workforce_permissions)) {
            if (key == workforcePk) {
                workforcePerms = [ ...value ];
            }
        }
        const workforcePermissions = [
            'view_employment', 'view_userprofile',
            'view_employmentpolicy', 'view_workforce'
        ];
        let hasAdministratorAccess = workforcePermissions.some(perm => workforcePerms.includes(perm));
        // TODO (rob@bposeast.com): We need to refactor this to make sure that it checks if the user is a workforce
        // or organizational executive of the workforce being navidated to, and not just any executive not related
        // to the workforce being navigated to.
        const { is_organizational_exec, is_workforce_exec, is_hr } = store.state.auth.user.user_profile;

        if (to.name === 'template-maker' && is_hr) {
            return next();
        }

        if (!is_organizational_exec && !is_workforce_exec && !hasAdministratorAccess) next(
            { name: 'access-denied', replace: true });
        else next();
    },

    children: [{
            path: 'workforces',
            name: 'administrator-workforces',
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/WorkforcesPage.vue'
                ),
            props: true,
            meta: {
                title: 'Workforce Details - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
            {
                path: 'workforce',
                name: 'workforce-details-page',
                component: () =>
                    import(
                        'source/pages/employers/administrator/sub-sections/WorkforceDetailsPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Workforce Details - HQZen',
                    canDisplayGlobalModals: true,
                    isAdministratorRoute: true,
                },
                children: [
                    {
                        path: 'single-onboarding',
                        name: 'single-onboarding',
                        component: () =>
                            import(
                                'source/pages/onboarding/OnboardingSingleStartPage.vue'
                            ),
                        props: true,
                        meta: {
                            title: 'Onboarding - HQZen',
                            canDisplayGlobalModals: true,
                            isAdministratorRoute: true,
                        },
                        children: [
                            {
                                path: 'employee-information',
                                name: 'single-onboarding-employee-information',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/SingleEmployeeOnboarding.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Onboarding - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                            {
                                path: 'contract-configuration',
                                name: 'single-onboarding-contract-configuration',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/OnboardingContractSetup.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Set up contract - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                            {
                                path: 'summary',
                                name: 'single-onboarding-employee-summary',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/SingleOnboardingSummary.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Single Employee Onboarding',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                            {
                                path: 'done',
                                name: 'single-onboarding-done',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/SingleOnboardingDone.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Onboarding - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                        ]
                    },
                    {
                        path: 'batch-onboarding',
                        name: 'batch-onboarding',
                        component: () =>
                            import(
                                'source/pages/onboarding/OnboardingBatchStartPage.vue'
                            ),
                        props: true,
                        meta: {
                            title: 'Onboarding - HQZen',
                            canDisplayGlobalModals: true,
                            isAdministratorRoute: true,
                        },
                        children: [
                            {
                                path: 'review-uploaded-data',
                                name: 'batch-onboarding-review-uploaded-data',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/ReviewUploadedDataPage.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Onboarding - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                            {
                                path: 'contract-configuration',
                                name: 'batch-onboarding-contract-configuration',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/OnboardingContractSetup.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Set up contract - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                            {
                                path: 'summary',
                                name: 'batch-onboarding-summary',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/BatchOnboardingSummary.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Onboarding - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                            {
                                path: 'done',
                                name: 'batch-onboarding-done',
                                component: () =>
                                    import(
                                        'source/pages/onboarding/BatchOnboardingDone.vue'
                                    ),
                                props: true,
                                meta: {
                                    title: 'Onboarding - HQZen',
                                    canDisplayGlobalModals: true,
                                    isAdministratorRoute: true,
                                },
                            },
                        ]
                    },
                ]
            },
        {
            path: 'onboard-employees',
            name: 'staff-onboard-employees',
            component: () =>
                import (
                    'source/pages/employers/employees/EmployeesOnboardPage.vue'
                ),
            props: true,
            meta: {
                title: 'Onboard Employees - HQZen',
                canDispladashboardyGlobalModals: true,
            },
        },
        {
            path: 'departments',
            name: 'administrator-departments',
            component: () =>
                import (
                    'source/pages/employers/departments/AdministratorDepartmentsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Departments - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'departments/:department_id',
            name: 'department-details-page',
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/DepartmentDetailsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Department Details - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'payment-dues',
            name: 'administrator-payment-dues',
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/PaymentDuesPage.vue'
                ),
            props: true,
            meta: {
                title: 'Payment Dues - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
            children: [{
                    path: 'view-invoice-details/:invoice_id/',
                    name: 'administrator-payment-dues-invoice-details',
                    component: () =>
                        import (
                            'source/components/employers/paymentdues/InvoiceDetailsModal.vue'
                        ),
                    props: true,
                    meta: {
                        title: 'HQZen',
                        canDisplayGlobalModals: false,
                        isAdministratorRoute: true,
                    },
                },
            ],
        },
        {
            path: 'templates',
            name: 'administrator-templates',
            beforeEnter: validateTemplatesTabRoute,
            component: () =>
                import (
                    'source/pages/employers/templates/TemplatesPage.vue'
                ),
            props: true,
            meta: {
                title: 'Templates - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'departments/teams/:team_id/employees/',
            name: 'departments-employee-page',
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/DepartmentEmployeesPage.vue'
                ),
            props: true,
            meta: {
                title: 'Employees - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
            {
                path: 'schedule-templates',
                name: 'staff-schedule-manager',
                component: () =>
                    import(
                        'source/pages/employers/staff/sub-sections/ScheduleManager.vue'
                    ),
                props: true,
                meta: {
                    title: 'Schedule Templates - HQZen',
                    canDispladashboardyGlobalModals: true,
                }
            },
            {
                path: 'create-schedule',
                        name: 'create-schedule-page',
                        component: () =>
                            import (
                                'source/pages/schedules/CreateSchedulePage.vue'
                            ),
                        props: true,
                        meta: {
                            title: 'Create Schedule - HQZen',
                            canDisplayGlobalModals: true,
                            isAdministratorRoute: true,
                        },
            },
            {
                path: 'edit-schedule/:scheduleGroupId',
                        name: 'edit-schedule-page',
                        component: () =>
                            import (
                                'source/pages/schedules/CreateSchedulePage.vue'
                            ),
                        props: true,
                        meta: {
                            title: 'Edit Schedule - HQZen',
                            canDisplayGlobalModals: true,
                            isAdministratorRoute: true,
                        },
            },
        {
            path: 'payrolls',
            name: 'administrator-payrolls',
            beforeEnter: canViewPayrolls,
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/Payrolls.vue'
                ),
            props: true,
            meta: {
                title: 'Payrolls - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'payrolls/employee-payrolls/:payroll_period_id',
            name: 'payroll-table',
            component: () =>
                import (
                    'source/pages/employers/payrolls/PayrollPeriodDetailsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Payroll Period - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'career-policies/:employment_policy_id',
            name: 'company-policy-view',
            component: () =>
                import (
                    'source/pages/employers/campaign-policy/CampaignPolicyView.vue'
                ),
            props: true,
            meta: {
                title: 'HR Policy - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'templates/:action/',
            name: 'template-maker',
            component: () =>
                import (
                    'source/pages/employers/templates/TemplateMakerPage.vue'
                ),
            props: true,
            meta: {
                title: 'Template Maker - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'scheduled-tasks',
            name: 'administrator-scheduled-tasks',
            component: () =>
                import ('source/pages/schedules/ScheduledTasksPage.vue'),
            props: true,
            meta: {
                title: 'Scheduled Tasks - HQZen',
                loginRequired: true,
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'scheduled-tasks/view/:assignee_id/:employment_id',
            name: 'view-administrator-scheduled-tasks',
            component: () =>
                import ('source/pages/schedules/EmployeeScheduledTasksPage.vue'),
            props: true,
            meta: {
                title: 'Partner Scheduled Tasks - HQZen',
                loginRequired: true,
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            }
        },
        {
            path: 'contracts',
            name: 'contracts',
            component: () =>
                import (
                    'source/pages/employers/staff/sub-sections/ContractsSection.vue'
                ),
            props: true,
            meta: {
                title: 'Contracts - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'separations/resignation/details',
            name: 'administrator-resignation-details',
            component: () =>
                import (
                    'source/pages/supervisor-manager/separations/ResignationDetailsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Separations - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        // {
        //     path: 'staff',
        //     name: 'staff-dashboard',
        //     component: () =>
        //         import ('source/pages/root/StaffPageGroup.vue'),
        //     props: true,
        //     meta: {
        //         title: 'Staff - HQZen',
        //         canDisplayGldashboardobalModals: true,
        //     },
        //     children: [{
        //             path: '',
        //             name: 'staff-employees',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/staff/sub-sections/Employees.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Employees - HQZen',
        //                 canDisplayDashboardGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'employee-information/:employee_id',
        //             name: 'employer-dashboard-employee-information',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/employees/EmployeeInformationSection.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Employee - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'employee-information/:employee_id/screenshots',
        //             name: 'employer-employee-screenshots',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/EmployerEmployeeScreenshotsPage.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Employee Screenshots - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'employee-information/:employee_id/employee-payroll/:employee_payroll_id',
        //             name: 'employer-payroll-employee',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/payrolls/EmployeeTimelogSection.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Employee Payroll - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'payroll-periods/:payroll_period_id',
        //             name: 'employer-payroll-period-list',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/payrolls/PayrollPeriodInformationSection.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Payroll Period - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'schedule-manager',
        //             name: 'staff-schedule-manager',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/staff/sub-sections/ScheduleManager.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Schedule Manager - HQZen',
        //                 canDispladashboardyGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'onboard-employees',
        //             name: 'staff-onboard-employees',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/employees/EmployeesOnboardPage.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Onboard Employees - HQZen',
        //                 canDispladashboardyGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'manual-onboard',
        //             name: 'staff-onboard-manual',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/employees/ManualOnboardFirstStepPage.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Manual Onboarding - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'manual-onboard-2',
        //             name: 'staff-onboard-manual-2',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/employees/ManualOnboardSecondStepPage.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Manual Onboard - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'onboard-status',
        //             name: 'staff-onboard-status',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/employees/OnboardStatusPage.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Success - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //         {
        //             path: 'employee-information/:employee_id/contract-workflow',
        //             name: 'contract-workflow',
        //             component: () =>
        //                 import (
        //                     'source/pages/employers/contracts/ContractWorkflowPage.vue'
        //                 ),
        //             props: true,
        //             meta: {
        //                 title: 'Contract Workflow - HQZen',
        //                 canDisplayGlobalModals: true,
        //             },
        //         },
        //     ],
        // },
        {
            path: 'exit-interviews',
            name: 'staff-exit-interview',
            component: () => {
                return import (
                    'source/pages/employers/staff/sub-sections/ExitInterviewSection.vue'
                );
            },
            props: true,
            meta: {
                title: 'Exit Interviews - HQZen',
                canDispladashboardyGlobalModals: true,
            },
        },
        {
            path: 'exit-interviews/details/:id',
            name: 'staff-exit-interview-details',
            component: () => {
                return import (
                    'source/pages/employers/staff/sub-sections/exit-interview/ExitInterviewDetailsPage.vue'
                );
            },
            props: true,
            meta: {
                title: 'Exit Interviews Details - HQZen',
                canDispladashboardyGlobalModals: true,
            },
        },
        {
            path: 'platform-settings',
            name: 'administrator-platform-settings',
            beforeEnter: validatePlatformSettingsRoute,
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/PlatformSettingsManager.vue'
                ),
            props: true,
            meta: {
                title: 'Platform Settings - HQZen',
                canDispladashboardyGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'create-platform-settings',
            name: 'create-platform-settings',
            beforeEnter: validatePlatformSettingsRoute,
            component: () =>
                import (
                    'source/pages/employers/platform-settings/CreatePlatformSettingsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Create Platform Settings - HQZen',
                canDispladashboardyGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'edit-platform-settings/:setting_id',
            name: 'edit-platform-settings',
            beforeEnter: validatePlatformSettingsRoute,
            component: () =>
                import (
                    'source/pages/employers/platform-settings/CreatePlatformSettingsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Edit Platform Settings - HQZen',
                canDispladashboardyGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'staff-configuration',
            name: 'administrator-staff-configuration',
            component: () => import (
                'source/pages/employers/administrator/StaffConfigurationManager.vue'
            ),
            meta: {
                title: 'Staff Configuration - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true
            },
        },
        {
            path: 'staff-configuration/create',
                name: 'staff-configuration-create',
                component: () => import (
                    'source/pages/employers/administrator/CreateStaffConfigPage.vue'
                ),
                meta: {
                    title: 'Staff Configuration Create - HQZen',
                    canDisplayGlobalModals: true,
                    isAdministratorRoute: true
                }
        },
        {
            path: 'workforce-settings',
            name: 'workforce-settings',
            component: () => import (
                    'source/pages/employers/administrator/sub-sections/WorkforceBoardSettings.vue'
                ),
            meta: {
                title: 'Shared Board Settings - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true
            }
        },
        {
            path: 'organization-settings',
            name: 'administrator-organization-settings',
            component: () =>
                import (
                    'source/pages/employers/settings/SettingsSectionPage.vue'
                ),
            props: true,
            meta: {
                title: 'Settings - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'onboarding-settings',
            name: 'administrator-onboarding-settings',
            beforeEnter: validateOnboardingSettingsRoute,
            component: () =>
                import (
                    'source/pages/employers/settings/onboarding/OnboardingSettingsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Onboarding Settings - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            }
        },
        {
            path: 'onboarding-settings/:configuration_id/onboarding-settings-details',
            name: 'administrator-onboarding-settings-details',
            component: () =>
                import (
                    'source/pages/employers/settings/onboarding/OnboardingSettingsDetailsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Onboarding Settings - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'onboarding-settings/create',
            name: 'administrator-onboarding-settings-create',
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/OnboardingConfigurationsCreatePage.vue'
                ),
            props: true,
            meta: {
                title: 'Create Configuration - HQZen',
                canDisplayGlobalModals: false,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'onboarding-settings/:configuration_id/update',
            name: 'administrator-onboarding-settings-update',
            component: () =>
                import (
                    'source/pages/employers/administrator/sub-sections/OnboardingConfigurationsUpdatePage.vue'
                ),
            props: true,
            meta: {
                title: 'Update Configuration - HQZen',
                canDisplayGlobalModals: false,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'permissions-settings',
            name: 'administrator-permissions-settings',
            beforeEnter: validateOnboardingSettingsRoute,
            component: () =>
                import (
                    'source/pages/employers/settings/permissions/PermissionsSettingsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Permissions Settings - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
            children: [{
                path: 'edit-work-schedule',
                name: 'edit-work-schedule-details-table',
                component: () =>
                    import (
                        'source/pages/employers/settings/permissions/PermissionDetailsSubpage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Edit Work Schedule - HQZen',
                    canDisplayGlobalModals: false,
                    isAdministratorRoute: true,
                },
            }],
        },
        {
            path: 'memorandums',
            name: 'administrator-memorandums',
            component: () =>
                import ('source/pages/memorandums/MemorandumsPage.vue'),
            props: true,
            meta: {
                title: 'Memorandums - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
        {
            path: 'memorandums/:memoId',
            name: 'administrator-memorandum-details',
            component: () =>
                import (
                    'source/pages/memorandums/MemorandumDetailsPage.vue'
                ),
            props: true,
            meta: {
                title: 'Memorandum Details - HQZen',
                canDisplayGlobalModals: true,
                isAdministratorRoute: true,
            },
        },
    ],
}, ];
